
import { Radio } from 'element-ui'

export default {
  extends: Radio,
}
